module.exports = __webpack_public_path__ + "img/feature-7.58688748.jpg";